"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MedicinalProductContraindicationOtherTherapy = void 0;
/**
 * The clinical particulars - indications, contraindications etc. of a medicinal product, including for regulatory purposes.
 */
var MedicinalProductContraindicationOtherTherapy = /** @class */ (function () {
    function MedicinalProductContraindicationOtherTherapy() {
    }
    return MedicinalProductContraindicationOtherTherapy;
}());
exports.MedicinalProductContraindicationOtherTherapy = MedicinalProductContraindicationOtherTherapy;
